import { render, staticRenderFns } from "./goodsTicket.vue?vue&type=template&id=3096a32d&scoped=true"
import script from "./goodsTicket.vue?vue&type=script&lang=js"
export * from "./goodsTicket.vue?vue&type=script&lang=js"
import style0 from "./goodsTicket.vue?vue&type=style&index=0&id=3096a32d&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3096a32d",
  null
  
)

export default component.exports